const img = (file) => `${process.env.PUBLIC_URL || ""}/img/${file}`;

const dots = () => `
    <div class="shots__dots" role="tablist" aria-label="Nuotraukos">
        <button type="button" class="is-on" data-dot aria-label="1" aria-current="true"></button>
        <button type="button" data-dot aria-label="2"></button>
        <button type="button" data-dot aria-label="3"></button>
        <button type="button" data-dot aria-label="4"></button>
    </div>
`;

const still = (id, file, label, on = false) => `
    <a class="still${on ? " is-on" : ""}" href="#paslaugos" data-app="${id}"${on ? ' aria-current="true"' : ""}>
        <img src="${img(file)}" alt="">
        <span data-i18n="sk.${id}">${label}</span>
    </a>
`;

export const landingMarkup = `
    <div class="boot" data-boot>
        <p class="boot__brand">ANTIUSDRAGON</p>
        <ol class="boot__log" data-boot-log></ol>
        <span class="boot__bar"><i data-boot-bar></i></span>
        <button class="boot__skip" type="button" data-skip data-i18n="skip">Praleisti</button>
    </div>

    <div class="glow" data-glow aria-hidden="true"></div>

    <section class="stage" data-stage>
        <div class="noise" aria-hidden="true"></div>
        <header class="top" data-chrome></header>

        <main class="studio">
            <section class="studio__work" data-win="skills" id="paslaugos">
                <p class="kicker" data-i18n="win.skills">Paslaugos</p>
                <div class="split">
                    <nav class="rail" aria-label="Paslaugos">
                        <button type="button" class="is-on" data-app="web" data-i18n="sk.web">Web</button>
                        <button type="button" data-app="sys" data-i18n="sk.sys">Sistemos</button>
                        <button type="button" data-app="home" data-i18n="sk.home">Namai</button>
                        <button type="button" data-app="d3" data-i18n="sk.d3">3D / braižyba</button>
                        <button type="button" data-app="netw" data-i18n="sk.netw">Tinklai</button>
                        <button type="button" data-app="auto" data-i18n="sk.auto">Automatizavimas</button>
                        <button type="button" data-app="design" data-i18n="sk.design">Dizainas</button>
                        <button type="button" data-app="model" data-i18n="sk.model">Modelis</button>
                    </nav>
                    <nav class="film" aria-label="Paslaugos">
                        ${still("web", "ad-web-site.jpg", "Web", true)}
                        ${still("sys", "ad-sys-one.jpg", "Sistemos")}
                        ${still("home", "ad-home-wall.jpg", "Namai")}
                        ${still("d3", "ad-d3-draw.jpg", "3D / braižyba")}
                        ${still("netw", "ad-net-rack.jpg", "Tinklai")}
                        ${still("auto", "ad-auto-rpa.jpg", "Automatizavimas")}
                        ${still("design", "ad-design-logo.jpg", "Dizainas")}
                        ${still("model", "ad-model-01.jpg", "Modelis")}
                    </nav>

                    <div class="view">
                    <div class="pane is-on" data-pane="web">
                        <div class="shots" data-shots>
                            <img class="view__shot is-on" src="${img("ad-web-site.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-web-shop.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-web-login.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-web-admin.jpg")}" alt="">
                            ${dots()}
                        </div>
                    </div>
                    <div class="pane" data-pane="sys">
                        <div class="shots" data-shots>
                            <img class="view__shot is-on" src="${img("ad-sys-one.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-sys-desk.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-sys-portal.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-sys-lic.jpg")}" alt="">
                            ${dots()}
                        </div>
                    </div>
                    <div class="pane" data-pane="home">
                        <div class="shots" data-shots>
                            <img class="view__shot is-on" src="${img("ad-home-wall.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-home-tablet.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-home-hall.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-home-gate.jpg")}" alt="">
                            ${dots()}
                        </div>
                    </div>
                    <div class="pane" data-pane="d3">
                        <div class="shots" data-shots>
                            <img class="view__shot is-on" src="${img("ad-d3-draw.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-d3-scan.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-d3-print.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-d3-parts.jpg")}" alt="">
                            ${dots()}
                        </div>
                    </div>
                    <div class="pane" data-pane="netw">
                        <div class="shots" data-shots>
                            <img class="view__shot is-on" src="${img("ad-net-rack.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-net-nas.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-net-nvr.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-net-vpn.jpg")}" alt="">
                            ${dots()}
                        </div>
                    </div>
                    <div class="pane" data-pane="auto">
                        <div class="shots" data-shots>
                            <img class="view__shot is-on" src="${img("ad-auto-rpa.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-auto-reports.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-auto-api.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-auto-flow.jpg")}" alt="">
                            ${dots()}
                        </div>
                    </div>
                    <div class="pane" data-pane="design">
                        <div class="shots" data-shots>
                            <img class="view__shot is-on" src="${img("ad-design-logo.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-design-system.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-design-web.jpg")}" alt="">
                            <img class="view__shot" src="${img("ad-design-ads.jpg")}" alt="">
                            ${dots()}
                        </div>
                    </div>
                    <div class="pane" data-pane="model">
                        <div class="shots" data-shots>
                            <div class="view__shot is-on">
                                <img class="shot__bleed" src="${img("ad-model-01.jpg")}" alt="" aria-hidden="true">
                                <img class="shot__photo" src="${img("ad-model-01.jpg")}" alt="">
                            </div>
                            <div class="view__shot">
                                <img class="shot__bleed" src="${img("ad-model-03.jpg")}" alt="" aria-hidden="true">
                                <img class="shot__photo" src="${img("ad-model-03.jpg")}" alt="">
                            </div>
                            <div class="view__shot">
                                <img class="shot__bleed" src="${img("ad-model-06.jpg")}" alt="" aria-hidden="true">
                                <img class="shot__photo" src="${img("ad-model-06.jpg")}" alt="">
                            </div>
                            <div class="view__shot">
                                <img class="shot__bleed" src="${img("ad-model-09.jpg")}" alt="" aria-hidden="true">
                                <img class="shot__photo" src="${img("ad-model-09.jpg")}" alt="">
                            </div>
                            ${dots()}
                        </div>
                    </div>
                    <div class="copy-slot">
                        <div class="view__copy is-on" data-copy="web" aria-hidden="false">
                            <p class="pane__k" data-i18n="sk.web.k">Svetainės ir web sistemos</p>
                            <p class="pane__p" data-i18n="sk.web.p">Svetainė su paskyra, administravimu ir duomenimis. Veikia ir plečiama.</p>
                            <ul class="tags">
                                <li>Laravel</li>
                                <li>React</li>
                                <li>PHP</li>
                                <li>MySQL</li>
                                <li>JS</li>
                            </ul>
                        </div>
                        <div class="view__copy" data-copy="sys" aria-hidden="true">
                            <p class="pane__k" data-i18n="sk.sys.k">Verslo sistemos</p>
                            <p class="pane__p">
                                <span data-i18n="sk.sys.p">Darbastalio programa, portalas ir licencijos — viena sistema. Darbas kompiuteryje, valdymas naršyklėje.</span>
                                <a href="https://os.antiusdragon.com" target="_blank" rel="noopener noreferrer">OS</a>
                                <span data-i18n="sk.sys.and">ir</span>
                                <a href="https://open-folder.antiusdragon.com" target="_blank" rel="noopener noreferrer">Open Folder</a>.
                            </p>
                            <ul class="tags">
                                <li>Windows</li>
                                <li>Laravel</li>
                                <li data-i18n="sk.sys.lic">Licencijos</li>
                            </ul>
                        </div>
                        <div class="view__copy" data-copy="home" aria-hidden="true">
                            <p class="pane__k" data-i18n="sk.home.k">Išmanieji namai</p>
                            <p class="pane__p" data-i18n="sk.home.p">Šviesa, šildymas, elektra ir prieiga — viena namų sistema. Valdymas iš vieno ekrano visam namui, automatikos veikia pačios. Paliekama veikti ir plėsti.</p>
                            <ul class="tags">
                                <li>Home Assistant</li>
                                <li>Node-RED</li>
                                <li>Zigbee</li>
                            </ul>
                        </div>
                        <div class="view__copy" data-copy="d3" aria-hidden="true">
                            <p class="pane__k" data-i18n="sk.d3.k">3D modeliavimas ir braižyba</p>
                            <p class="pane__p" data-i18n="sk.d3.p">Brėžinys, kurį galima gaminti — ne tik peržiūrėti. 2D ir 3D, korekcijos ir perbraižymas. Objekto skenavimas ir dervos spauda smulkioms detalėms, iki 14,5 × 14,5 × 18,5 cm.</p>
                            <ul class="tags">
                                <li>2D / 3D</li>
                                <li data-i18n="sk.d3.scan">Skenavimas</li>
                                <li data-i18n="sk.d3.print">Dervos spauda</li>
                            </ul>
                        </div>
                        <div class="view__copy" data-copy="netw" aria-hidden="true">
                            <p class="pane__k" data-i18n="sk.netw.k">Tinklai ir saugykla</p>
                            <p class="pane__p" data-i18n="sk.netw.p">Tinklas, saugykla ir stebėjimas — viena infrastruktūra objektui. Failai su teisėmis ir atsarginėmis kopijomis, nuotolinė prieiga, kameros visoje teritorijoje.</p>
                            <ul class="tags">
                                <li>NAS</li>
                                <li>NVR</li>
                                <li>Switch</li>
                                <li>Wi-Fi</li>
                                <li>VPN</li>
                                <li>PoE</li>
                            </ul>
                        </div>
                        <div class="view__copy" data-copy="auto" aria-hidden="true">
                            <p class="pane__k" data-i18n="sk.auto.k">Procesų automatizavimas</p>
                            <p class="pane__p" data-i18n="sk.auto.p">Pasikartojantys darbai paliekami sistemai: ataskaitos, duomenų perkėlimas, programų sujungimas. Tas pats nebekartojamas ranka kiekvieną dieną.</p>
                            <ul class="tags">
                                <li>RPA</li>
                                <li>API</li>
                                <li data-i18n="sk.auto.int">Integracija</li>
                            </ul>
                        </div>
                        <div class="view__copy" data-copy="design" aria-hidden="true">
                            <p class="pane__k" data-i18n="sk.design.k">Vizualinis identitetas</p>
                            <p class="pane__p" data-i18n="sk.design.p">Prekės ženklas sudedamas į vieną sistemą: logotipas, spalvos, šriftas. Tas pats identitetas svetainėje, blankuose ir reklamoje.</p>
                            <ul class="tags">
                                <li data-i18n="sk.design.logo">Logotipas</li>
                                <li data-i18n="sk.design.id">Identitetas</li>
                                <li data-i18n="sk.design.ads">Reklama</li>
                            </ul>
                        </div>
                        <div class="view__copy" data-copy="model" aria-hidden="true">
                            <p class="pane__k" data-i18n="sk.model.k">Modelis reklamai ir filmui</p>
                            <p class="pane__p" data-i18n="sk.model.p">Veidas kadre: reklama, komercinė fotografija, vaizdo klipai ir vaidmuo. Nuotrauka ar filmas — tas pats žmogus prieš kamerą.</p>
                            <a class="go" href="https://deimante.lt/modeliai/antanas/" data-i18n="sk.model.go">Profilis →</a>
                        </div>
                    </div>
                    </div>
                </div>
            </section>

            <section class="studio__cta" id="kontaktai">
                <p class="kicker" data-i18n="cta.k">Kontaktai</p>
                <div class="split">
                    <div class="rail" aria-hidden="true"></div>
                    <div class="contact">
                        <div class="contact__who">
                            <p class="pane__k">Antanas Urbanavičius</p>
                            <p class="contact__place">Vievis</p>
                            <p class="pane__p" data-i18n="cta.p">Sistema, svetainė ar kadras reklamai — parašykite, aptarsime.</p>
                        </div>
                        <div class="contact__ways">
                            <a href="mailto:info@antiusdragon.lt">
                                <span class="contact__label" data-i18n="cta.mail">El. paštas</span>
                                <span>info@antiusdragon.lt</span>
                            </a>
                            <a href="tel:+37060807896">
                                <span class="contact__label" data-i18n="cta.phone">Telefonas</span>
                                <span>+370 608 07896</span>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </section>

    <nav class="dock" aria-label="AntiusDragon">
        <a href="#paslaugos" class="is-on" data-dock="paslaugos" data-scroll="paslaugos" data-i18n="nav.skills">Paslaugos</a>
        <a href="#kontaktai" data-dock="kontaktai" data-scroll="kontaktai" data-i18n="nav.contact">Kontaktai</a>
    </nav>

    <footer class="end">
        <span>© <span data-year></span> AntiusDragon</span>
        <nav class="end__social" aria-label="Socialiniai tinklai">
            <a href="https://www.tiktok.com/@antius.dragon" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z"/></svg>
            </a>
            <a href="https://www.instagram.com/antius.dragon/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/></svg>
            </a>
            <a href="https://www.facebook.com/Antius.Dragon" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H8.08V12h2.36V9.8c0-2.33 1.39-3.62 3.52-3.62.99 0 2.03.18 2.03.18v2.23h-1.14c-1.13 0-1.48.7-1.48 1.42V12h2.52l-.4 2.89h-2.12v6.99A10 10 0 0 0 22 12z"/></svg>
            </a>
        </nav>
    </footer>
`;
